import { render, staticRenderFns } from "./CancelledDeliveriesDriverConfig.vue?vue&type=template&id=34a1db54&scoped=true"
import script from "./CancelledDeliveriesDriverConfig.vue?vue&type=script&lang=js"
export * from "./CancelledDeliveriesDriverConfig.vue?vue&type=script&lang=js"
import style0 from "./CancelledDeliveriesDriverConfig.vue?vue&type=style&index=0&id=34a1db54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a1db54",
  null
  
)

export default component.exports